export const ANALYTICS_APP_EXTERNAL = process.env.REACT_APP_ANALYTICS_APP_EXTERNAL; //local 'http://analytics-local'
export const KATANA_WIDGET_DOMAIN = process.env.REACT_APP_KATANA_WIDGET_DOMAIN;
export const KATANA_API_KEY = {
  'mygp.cz': process.env.REACT_APP_KATANA_API_KEY_DANUBE,
  'mygp.sk': process.env.REACT_APP_KATANA_API_KEY_DANUBE,
  'mygp.at': process.env.REACT_APP_KATANA_API_KEY_DANUBE,
  'mygp.ro': process.env.REACT_APP_KATANA_API_KEY_DANUBE,
  'mygp.de': process.env.REACT_APP_KATANA_API_KEY_CBK_DE,
  'genius.us': process.env.REACT_APP_KATANA_API_KEY_GENIUS_US,
  'genius.ca': process.env.REACT_APP_KATANA_API_KEY_GENIUS_CA,
  'worldpay.us': process.env.REACT_APP_KATANA_API_KEY_WORLDPAY_US
};
export const KATANA_DOMAIN = process.env.REACT_APP_KATANA_DOMAIN;
export const CRM_PROC_URL = process.env.REACT_APP_CRM_PROC_URL;

export const endpoints = {
  GET_MERCHANT_DATA_BY_KEYS: 'api/v2/AceHosting/getMerchantDataByKeys'
};
